import _extends from "../../node_modules/@babel/runtime/helpers/esm/extends.es.js";
import "react";
import { DIALOG_WIDTH } from "../constants/dimensions.es.js";
import { j as jsxRuntimeExports } from "../../../../react/jsx-runtime.es.js";
import styled from "../../../material/styles/styled.es.js";
import MuiDialog from "../../../material/Dialog/Dialog.es.js";
import dialogClasses from "../../../material/Dialog/dialogClasses.es.js";
import MuiDialogContent from "../../../material/DialogContent/DialogContent.es.js";
import Fade from "../../../material/Fade/Fade.es.js";
const PickersModalDialogRoot = styled(MuiDialog)({
  [`& .${dialogClasses.container}`]: {
    outline: 0
  },
  [`& .${dialogClasses.paper}`]: {
    outline: 0,
    minWidth: DIALOG_WIDTH
  }
});
const PickersModalDialogContent = styled(MuiDialogContent)({
  "&:first-of-type": {
    padding: 0
  }
});
function PickersModalDialog(props) {
  const {
    children,
    onDismiss,
    open,
    slots,
    slotProps
  } = props;
  const Dialog = (slots == null ? void 0 : slots.dialog) ?? PickersModalDialogRoot;
  const Transition = (slots == null ? void 0 : slots.mobileTransition) ?? Fade;
  return /* @__PURE__ */ jsxRuntimeExports.jsx(Dialog, _extends({
    open,
    onClose: onDismiss
  }, slotProps == null ? void 0 : slotProps.dialog, {
    TransitionComponent: Transition,
    TransitionProps: slotProps == null ? void 0 : slotProps.mobileTransition,
    PaperComponent: slots == null ? void 0 : slots.mobilePaper,
    PaperProps: slotProps == null ? void 0 : slotProps.mobilePaper,
    children: /* @__PURE__ */ jsxRuntimeExports.jsx(PickersModalDialogContent, {
      children
    })
  }));
}
export {
  PickersModalDialog
};
//# sourceMappingURL=PickersModalDialog.es.js.map
